
/**
 * Adds stylesheet rules to the document's head.
 * @returns {Function} A function that accepts an array of rules and adds them to the stylesheet.
 */
const addStylesheetRules = function() {
  const styleEl = document.createElement('style');
  // Append <style> element to <head>
  document.head.appendChild(styleEl);
  // Grab style element's sheet
  const styleSheet = styleEl.sheet;

  return function(rules) {
    for (let i = 0; i < rules.length; i++) {
      let j = 1;
      let rule = rules[i];
      const selector = rule[0];
      let propStr = '';
      // If the second argument of a rule is an array of arrays, correct our variables.
      if (Array.isArray(rule[1][0])) {
        rule = rule[1];
        j = 0;
      }

      for (let pl = rule.length; j < pl; j++) {
        const prop = rule[j];
        propStr += `${prop[0]}: ${prop[1]}${prop[2] ? ' !important' : ''};\n`;
      }

      // Insert CSS Rule
      styleSheet.insertRule(
          `${selector}{${propStr}}`,
          styleSheet.cssRules.length,
      );
    };
  };
}();


const setBreakpointClasses = function() {
  // setup match media items
  const breakpointSm = window.matchMedia('(min-width: 576px)');
  const breakpointMd = window.matchMedia('(min-width: 768px)');
  const breakpointLg = window.matchMedia('(min-width: 992px)');
  const breakpointXl = window.matchMedia('(min-width: 1500px)');
  const breakpointXxl = window.matchMedia('(min-width: 2000px)');

  // function to run when checking for changes in the media query
  const breakpointChecker = function() {
    let breakpoint = null;

    switch (true) {
      case breakpointXxl.matches:
        breakpoint = 'xxl';
        break;
      case breakpointXl.matches:
        breakpoint = 'xl';
        break;
      case breakpointLg.matches:
        breakpoint = 'lg';
        break;
      case breakpointMd.matches:
        breakpoint = 'md';
        break;
      case breakpointSm.matches:
        breakpoint = 'sm';
        break;
      default:
        breakpoint = 'xs';
    }

    document.body.classList.remove(
        'window-xs',
        'window-sm',
        'window-md',
        'window-lg',
        'window-xl',
        'window-xxl');
    if (breakpoint) {
      document.body.classList.add(`window-${breakpoint}`);
    }
  };

  breakpointChecker();

  breakpointSm.addEventListener('change', breakpointChecker);
  breakpointMd.addEventListener('change', breakpointChecker);
  breakpointLg.addEventListener('change', breakpointChecker);
  breakpointXl.addEventListener('change', breakpointChecker);
  breakpointXxl.addEventListener('change', breakpointChecker);
};

setBreakpointClasses();


const buildRules = function() {
  const els = document.querySelectorAll(
      '.section[data-bg-lg], .section[data-bg-xl], .section[data-bg-xxl]');
  els.forEach(function(el) {
    const bg = el.getAttribute('data-bg-lg');
    const bgXl = el.getAttribute('data-bg-xl');
    const bgXxl = el.getAttribute('data-bg-xxl');

    const prefix = 'window';
    const baseSelector = `.section[data-section-id="${el.getAttribute('data-section-id')}"]::before`;

    // build array of rules to add to the stylesheet
    const rules = [];

    if (bg) {
      rules.push([
        `.${prefix}-lg ${baseSelector}`,
        ['background-image', `url(${bg})`],
      ]);
    }

    if (bgXl) {
      rules.push([
        `.${prefix}-xl ${baseSelector}`,
        ['background-image', `url(${bgXl})`],
      ]);
    }

    if (bgXxl) {
      rules.push([
        `.${prefix}-xxl ${baseSelector}`,
        ['background-image', `url(${bgXxl})`],
      ]);
    }

    if (bgXxl) {
      rules.push([
        `.${prefix}-xxl ${baseSelector}`,
        ['background-image', `url(${bgXxl})`],
      ]);
    }

    addStylesheetRules(rules);
  });
};

export default buildRules;
